/**
 * 系统管理 菜单管理
 */
<template>
  <div class="main">
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>导购工具</el-breadcrumb-item>
      <el-breadcrumb-item>默认名片</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
       <div class="formout">
		   <div class="formleft">
			   <div class="title1">名片结构</div>
			   <div class="out">
				   <div class="title2">基本信息（头像、姓名、手机号、地址）</div>
				   <div class="jie">纽恩泰介绍</div>
				   <div class="jie">公司介绍</div>
			   </div>
		   </div>
		   <el-form label-width="120px" ref="editForm" class="editForm">
		    
		    <el-form-item   label="纽恩泰简介">
		      
		      <el-upload
		        class="upload-demo"
		        :action="uploadUrl()"
		        :http-request="customUpload"
		        :on-preview="handlePreview"
		        :on-remove="handleRemove"
		        :file-list="resultFilelist1"
		        :limit='1'
		        accept=".png,.jpg,.jpeg"
		        list-type="picture-card">
				<div slot="file" slot-scope="{file}">
					<el-progress type="circle" :percentage="progressPercent" v-if="isUpload"></el-progress>
				     <img
				       class="el-upload-list__item-thumbnail"
				       :src="file.url" alt=""
				     >
				     <span class="el-upload-list__item-actions">
				      <!-- <span
				         class="el-upload-list__item-preview"
				         @click="handlePictureCardPreview(file)"
				       >
				         <i class="el-icon-zoom-in"></i>
				       </span>
				       <span
				         v-if="!disabled"
				         class="el-upload-list__item-delete"
				         @click="handleDownload1(file)"
				       >
				         <i class="el-icon-download"></i>
				       </span> -->
				       <span
				         class="el-upload-list__item-delete"
				         @click="handleRemove(file)"
				       >
				         <i class="el-icon-delete"></i>
				       </span>
				     </span>
				 </div>
		        <el-button size="small" type="primary">点击上传图片</el-button>
		        <div slot="tip" class="el-upload__tip">只能上传jpg、jpeg、png 图片，最多可上传1张图片</div>
		      </el-upload>
		      
		    </el-form-item>
		     <div slot="footer" class="dialog-footer">
		       <el-button size="small" type="primary" :loading="loading" class="title" @click="saveProInfo">预览</el-button>
		     </div>
		     
		     
		   </el-form>
	   </div>
        
        
		
		
		
		
		
		
		
		
		
		
      </div>
    </template>

    <script>
    // 导入请求方法
	import { uploadFile } from '../../api/axiosFun';
    import {
      saveDefaultCard,
	  getDefaultCard 
      } from '../../api/knowledgeFun'
    import Pagination from '../../components/Pagination'

  
    import {evaluateUpload }from '@/api/auth';
    import { setCookie, getCookie, delCookie } from '../../utils/util'



    export default {
      data() {
        return {
          loading: false, //是显示加载
		  isUpload: false,//文件是否上传中
		  progressPercent: 0,//进度条当前进度
		  diaFrom:{
		    desc:'',
		    list:[]
		  },
         resultFilelist1:[]
         
        }
      },
      // 注册组件
      components: {
        Pagination
      },

      /**
       * 数据发生改变
       */
      watch: {},

      /**
       * 创建完毕
       */
      created() {
        this.handleEdit()

      },
      mounted(){
		 
      },
      beforeDestroy(){
        // document.removeEventListener("paste",this.handlePaste);
      },
      /**
       * 里面的方法只有被调用才会执行
       */
      methods: {
		 
		  onUploadSuccess(response,file,fileList){
		    console.log('onUploadSuccess',response)
		    
		  },
		  beforeAvatarUpload(file){
		    console.log(file)
		  },
		  //限制上传个数不超过9个
		  handleExceed(files,fileList){
		    if(fileList && fileList.length == 1){
		      this.$message.warning('上传文件不可超过1个')
		    }
		  },
		  //显示编辑界面
		  handleEdit: function() {
		    let _this = this
		   
		   getDefaultCard().then(res => {
		       console.log(res)
		       this.loading = false
		       if (res.success == false) {
		         this.$message({
		           type: 'info',
		           message: res.msg+'TraceId:'+res.traceId
		         })
		       } else {
		         console.log(res)
		         let data = res.data
		        
				 this.resultFilelist = []
				
				 
				this.resultFilelist1.push({
				  url:data.pictureInfo.fileTemporaryUrl,
				  fileTemporaryUrl:data.pictureInfo.fileTemporaryUrl,
				  fileId:data.pictureInfo.fileId,
				  name: data.pictureInfo.ossFile.fileName,
				})
				   
					 
				 }
				 
		   		  
		         
		     })
		   
		   
		  },
		  uploadUrl(){
		    return '/mtl/marking/api/main/oss-file/upload-file'
		  },
		  handlePreview(file){
		    console.log(file)
		   
		  },
		  
		  customUpload(req){
		    let _this = this
		    console.log(req)
		     // 创建一个新的FormData对象
		    const formData = new FormData();
		    // 将文件添加到formData中
		    formData.append('file', req.file);
		    this.isUpload = true
		    this.progressPercent = 45
		      uploadFile(this.uploadUrl(), formData).then(response => {
				 
		        if(response.data.success){
					this.progressPercent = 100
					setTimeout(()=>{
						this.isUpload = false
					},1500)
		          let data = response.data.data
		          console.log(data)
		          _this.resultFilelist1.push({
		                  url:data.fileTemporaryUrl,
		                  fileTemporaryUrl:data.fileTemporaryUrl,
		                  fileId:data.fileId,
		                  name: data.ossFile.fileName,
		                  uid: req.file.uid,
		                  mediaObjInfo:data
		              })
		            
		          _this.saveProInfo()
		          
		        }else{
		          this.$message.error('文件上传失败，请稍后再试！')
		        }
		       console.log(99999999,_this.resultFilelist)
		        // 处理响应
		      }).catch(error => {
		        // 处理错误
		        console.log(error)
		         this.$message.error('文件上传失败，请稍后再试！')
		      });
		  },
		 
		  handleRemove(file,fileList){
		    let _this = this
		    console.log(file)
		    if(!file){
		      return
		    }
		    const index = this.resultFilelist1.findIndex(item => item.fileId === file.fileId)
		     console.log(index)
		     this.resultFilelist1.splice(index,1);
		  },
		 
        // 编辑、添加提交方法
        saveProInfo(){
           
			let formProInfo = this.resultFilelist1[0].mediaObjInfo
            saveDefaultCard(formProInfo).then(res => {
              this.loading = false
              if (res.success == false) {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              } else {
               this.$message({
                 type: 'success',
                 message: '上传成功'
               })
              }
            })
    		
        },

      


      }
    }
    </script>

    <style scoped>
    .user-search {
		position: absolute;
		top: 20px;
		right: 20px;
		width: 100px;
    }
    .userRole {
      width: 100%;
    }
    .main{
    	background-color: #fff;
    	padding: 30px;
    	border-radius: 10px;
		width: 90%;
		height: 500px;
    }
    /* .avatar-uploader{
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
    } */
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .editForm{
	  margin: 0 auto;
	  width: 50%;
	  height: 100%;
	  display: grid;
	  place-items: center;
	  float: right;
	  
  }
  .el-select{
	  width: 100%;
  }
  .dialog-footer{
	  margin: 0 auto;
	  margin-top: 30px;
	  width: 480px;
	  padding-left: 120px;
  }
  .title{
	  width: 100%;
  }
  .formleft{
	  width: 360px;
	  height: 400px;
	  float: left;
	  
  }
  .title1{
	  height: 30px;
	  line-height: 30px;
	  font-size: 12px;
	  margin-top: 30px;
  }
  .formout{
	  width: 100%;
	  height: 400px;
  }
  .out{
	  width: 300px;
	  border: 1px solid #d9d9d9;
	  border-radius: 10px;
	  height: 400px;
	  font-size: 14px;
	  padding: 10px;
  }
  .title2{
	  height: 60px;
	  width: 100%;
	  background-color: #d9d9d9;
	  text-align: center;
	  line-height: 60px;
	  border-radius: 10px;
  }
  .jie{
	  height: 160px;
	  width: 100%;
	  background-color: #d9d9d9;
	  text-align: center;
	  line-height: 160px;
	  border-radius: 10px;
	  margin-top: 10px;
  }
    </style>





// WEBPACK FOOTER //
// src/views/guidetool/businesscard.vue